import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import '../../App.css';
import InputData from '../../components/Inputs/InputData/InputData';
import InputSelect from '../../components/Inputs/InputSelect/InputSelect';
import InputTexto from '../../components/Inputs/InputTexto/InputTexto';
import Pagina from '../../components/Pagina/Pagina';
import api from '../../services/api';
import { getFiltroPadraoRelatorioEntregaPedidos } from '../../utils/filtros';
import { gridColumn } from '../../utils/gridColumn';
import { baixarArquivoBase64 } from '../../utils/download';
import InputFiltro from '../../components/Inputs/InputFiltro/InputFiltro';
import InputAutoComplete from '../../components/Inputs/InputAutoComplete/InputAutoComplete';
import Filtros from '../../components/Filtros/Filtros';
import InputToggle from '../../components/Inputs/InputToggle/InputToggle';
import FormikPadrao from '../../components/FormikPadrao/FormikPadrao';
import BarraBotoes from '../../components/BarraBotoes/BarraBotoes';
import TotalizadorRelatorio from '../../components/TotalizadorRelatorio/TotalizadorRelatorio';
import Tabela from '../../components/Tabela/Tabela';
import { ajustaDatas, optionsDatas } from '../../utils/utils';
import InputNumInt from '../../components/Inputs/InputNumInt/InputNumInt';

function RelEntregaPedidos() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [search] = useSearchParams();
  const [searchBar, setSearchBar] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [relEntregaPedidos, setRelEntregaPedidos] = useState([]);
  const [totalVendas, setTotalVendas] = useState(0);
  const [totalFrete, setTotalFrete] = useState(0);

  async function GetRelEntregaPedidos(filtros) {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(filtros, null, 2),
    };
    let res = await api.post('/EntregaPedidosReport/GetList', payload);
    let data = res.data;
    if (res.status === 200) {
      setRelEntregaPedidos(data.Pedidos);
      if (data.Pedidos && Object.keys(data.Pedidos).length > 0) {
        let vendas = data.Pedidos.length;
        let frete = 0;
        data.Pedidos.map(rel => (frete += rel.ValorFrete));
        setTotalVendas(vendas);
        setTotalFrete(frete);
      } else {
        setTotalVendas(0);
        setTotalFrete(0);
      }
      setLoading(false);
    } else {
      alert('Erro ao buscar dados');
    }
  }

  useEffect(() => {
    GetRelEntregaPedidos(getFiltroPadraoRelatorioEntregaPedidos());
  }, []);

  useEffect(() => {
    if (search.get('filter')) {
      setShowFilters(search.get('filter') === 'true');
      GetRelEntregaPedidos(getFiltroPadraoRelatorioEntregaPedidos());
    }
  }, [search]);

  const getPDF = async () => {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(relEntregaPedidos, null, 2),
    };
    baixarArquivoBase64('/EntregaPedidosReport/GetPDF', payload);
  };

  const getExcel = async () => {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(relEntregaPedidos, null, 2),
    };
    baixarArquivoBase64('/EntregaPedidosReport/GetExcel', payload);
  };

  function handleEdit(item) {
    navigate(`/Pedidos/Editar/${item.Id}`);
  }

  return (
    <Pagina loading={loading}>
      <FormikPadrao
        initialValues={getFiltroPadraoRelatorioEntregaPedidos()}
        onSubmit={async values => {
          await GetRelEntregaPedidos(values);
        }}
      >
        <BarraBotoes
          maxWindowSize={1030}
          botoes={[
            {
              children: 'Exportar Planilha',
              onClick: getExcel,
              variant: 'verde',
            },
            {
              children: 'Exportar PDF',
              onClick: getPDF,
              variant: 'rosa',
            },
          ]}
          search={{
            placeholder: 'Procurar por pedidos',
            onChange: e => setSearchBar(e.target.value),
          }}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
        />
        <FilterMenu showFilters={showFilters} setShowFilters={setShowFilters} />
        <TotalizadorRelatorio
          items={[
            {
              Titulo: 'QUANTIDADE DE VENDAS',
              Valor: totalVendas,
            },
            {
              Titulo: 'VALOR TOTAL DE FRETE',
              Valor: totalFrete,
              type: 'money',
            },
          ]}
        />
        <Tabela
          titulo={'RELATÓRIO DE ENTREGA DE PEDIDOS'}
          setFunction={setRelEntregaPedidos}
          data={relEntregaPedidos}
          columns={[
            {
              placeholder: 'PEDIDO',
              name: 'Codigo',
              type: 'text',
            },
            {
              placeholder: 'EMPRESA',
              name: 'Empresa',
              type: 'text',
            },
            {
              placeholder: 'CLIENTE',
              name: 'Cliente',
              type: 'text',
            },
            {
              placeholder: 'PREVISÃO DE ENTREGA',
              name: 'PrevisaoEntrega',
              type: 'date',
            },
            {
              placeholder: 'SITUAÇÃO',
              name: 'Situacao',
              type: 'text',
            },
            {
              placeholder: 'TRANSPORTADORA',
              name: 'Transportadora',
              type: 'date',
            },
            {
              placeholder: 'ENDEREÇO',
              name: 'Endereco',
              type: 'text',
            },
            {
              placeholder: 'VALOR FRETE',
              name: 'ValorFrete',
              type: 'money',
            },
          ]}
          searchBar={searchBar}
          handleEdit={handleEdit}
        />
      </FormikPadrao>
    </Pagina>
  );
}

function FilterMenu({ showFilters, setShowFilters }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    ajustaDatas(values.PeriodoLancamento, setFieldValue);
  }, [values.PeriodoLancamento, setFieldValue]);

  return (
    <Filtros showFilters={showFilters} setShowFilters={setShowFilters}>
      <InputFiltro
        titulo="CÓDIGO"
        id="Codigo"
        name="Codigo"
        component={InputNumInt}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="CLIENTE/FORNECEDOR"
        id="Cliente"
        name="Cliente"
        component={InputAutoComplete}
        autocomplete={true}
        path={'ClienteFornecedor'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="EMPRESA"
        id="Empresa"
        name="Empresa"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Empresa'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="TRANSPORTADORA"
        id="Transportadora"
        name="Transportadora"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Transportadoras'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="APENAS FATURADOS?"
        id="ApenasFaturados"
        name="ApenasFaturados"
        component={InputToggle}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="PERÍODO"
        id="PeriodoLancamento"
        name="PeriodoLancamento"
        component={InputSelect}
        options={optionsDatas}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="Data Inicial"
        id="DataInicial"
        name="DataInicial"
        component={InputData}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="Data Final"
        id="DataFinal"
        name="DataFinal"
        component={InputData}
        gridColumn={gridColumn.gc4}
      />
    </Filtros>
  );
}
export default RelEntregaPedidos;
